<template>
  <div class="card">
    <div v-if="canEdit" class="card__more-menu">
      <v-popover placement="auto" trigger="click">
        <icon class="more-menu" icon="ui-more-vert" />
        <template slot="popover">
          <div class="more-menu__list">
            <div v-close-popover class="more-menu__item" @click="onEditClicked">
              <icon class="item__edit" icon="ui-edit" />
              <p>Редактировать</p>
            </div>
            <div
              v-close-popover
              class="more-menu__item"
              @click="onDeleteClicked"
            >
              <icon class="item__delete" icon="ui-delete" />
              <p>Удалить</p>
            </div>
          </div>
        </template>
      </v-popover>
    </div>
    <img class="card__img" :src="card.logo" />
    <div class="card__title">
      {{ card.name }}
    </div>
    <div class="card__subtitle">
      {{ card.description }}
    </div>
    <div class="card__line" />
    <div v-if="!code" class="card__price">
      {{ card.title }}
    </div>
    <div v-else class="card__code">Ваш промокод:</div>
    <br />
    <b> {{ code }}</b>
    <div v-if="!code" class="card__bonus">
      {{ card.subtitle }}
    </div>
    <div v-else-if="deadline" class="card__subtitle">
      👆 промокод действует до {{ deadline }}
    </div>
    <a
      v-if="!code"
      class="card__btn"
      :href="card.url"
      target="_blank"
      @click.prevent="getCode(card.slug, card.url)"
    >
      Получить</a
    >
    <a v-else class="card__btn" :href="card.url" target="_blank"> Перейти</a>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Card',
  props: {
    card: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    previewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      code: null,
      url: null,
      deadline: null
    };
  },
  methods: {
    onEditClicked() {
      this.$emit('card-edit', this.card);
    },
    onDeleteClicked() {
      this.$emit('card-delete', this.card);
    },
    // ???? бизнес логика
    getCode: async function (code, refLink) {
      if (!this.previewMode) {
        let response = {};

        const res = await this.$store.dispatch(
          'ajax/axiosSend',
          {
            type: 'get',
            query: '/promocodes/' + code
          },
          { root: true }
        );

        if (res && res.data.status === 'success') {
          response = res.data;
        } else {
          window.open(refLink, '_blank').focus();
        }

        if (Object.keys(response.data).length !== 0) {
          this.code = response.data.code;
          this.deadline = moment(response.data.expiresIn).format('DD.MM.YYYY');
          this.url = response.data.partner.url;
        } else {
          window.open(refLink, '_blank').focus();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'style/utils';

.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  justify-self: center;

  background: #fff;
  border-radius: 8px;

  padding: 20px;

  font-size: 14px;
  font-weight: 500;
  color: #2b2d34;
  text-align: center;
  min-width: 275px;
  max-width: 400px;
  width: 100%;

  box-shadow: 0 4px 10px rgba(43, 45, 52, 0.12);

  &__more-menu {
    height: 20px;
    width: 20px;
    cursor: pointer;
    margin-left: auto;
    margin-bottom: -20px;

    .more-menu {
      height: 20px;
      width: 20px;
    }
  }

  &__img {
    height: 68px;
    width: 68px;
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: 20px;
    border: 1px solid #eff1f8;
  }

  &__title {
    @extend %text-500-16;
    margin-bottom: 8px;
    color: $ui-black;
    overflow-wrap: break-word;
  }

  &__code {
    font-size: 20px;
    margin-bottom: 8px;
    overflow-wrap: break-word;
  }

  &__subtitle {
    @extend %text-400-14;
    color: #76767b;
    height: 54px;
    margin-bottom: 20px;
    overflow-wrap: break-word;
  }

  &__line {
    height: 1px;
    width: 100%;
    background-color: #ceced6;
    margin-bottom: 20px;
  }

  &__price {
    @extend %text-500-20;
    color: $ui-black;
    margin-bottom: 8px;
    overflow-wrap: break-word;
  }

  &__bonus {
    @extend %text-400-14;
    color: $ui-black;
    margin-bottom: 20px;
    overflow-wrap: break-word;
  }

  &__btn {
    color: #6979f8;
    text-decoration: none;

    border: 1px solid #6979f8;
    border-radius: 4px;

    width: 100%;
    padding: 10px 0;
    margin: auto 0 0 0;

    cursor: pointer;
    transition: all 0.2s linear;
    &:hover {
      color: #fff;
      background-color: #6979f8;
    }
  }
}

.more-menu {
  &__list {
    background: $ui-white;
    border-radius: 4px;
    box-shadow: 0 4px 21px rgba(0, 0, 0, 0.09);
    padding: 10px;
  }
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    @include uiFont;
    @extend %text-400-14;
    margin-top: 8px;
    &:first-child {
      margin-top: 0;
    }
    svg {
      height: 22px;
      width: 22px;
      margin-right: 4px;
    }

    .item {
      &__edit {
        fill: $ui-gray-less-contrast;
      }

      &__delete {
        fill: $ui-red;
      }
    }
  }
}
</style>
